import DeviceSubtypeList from 'components/DeviceSubtypeList';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * Column for the device subtypes.
 */
export default function DeviceSubtypesColumn({ data: { deviceSubtype } }: { data: RevisionRow }) {
  return <DeviceSubtypeList deviceSubtypes={deviceSubtype} limit={1} />;
}
